/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * Payment status types used for online payments. Mapped from Wepay or from Global.Core.Enums.Merchants.PaymentProcessingServicePaymentStatus

ref: https://stage.wepay.com/developer/reference/checkout 

Must remain lower case1 = Sent

2 = Expired

3 = Authorized

4 = Failed

5 = Cancelled

6 = Reserved

7 = Charged Back

8 = Captured

9 = Refunded

10 = manually captured

11 = refunded and manually captured

12 = captured and not recorded

13 = Void

14 = Declined

15 = Scheduled


 */
export type PaymentStatusTypes =
  (typeof PaymentStatusTypes)[keyof typeof PaymentStatusTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentStatusTypes = {
  Unpaid: 1,
  Expired: 2,
  Authorized: 3,
  Failed: 4,
  Cancelled: 5,
  Reserved: 6,
  ChargedBack: 7,
  Captured: 8,
  Refunded: 9,
  ManuallyCaptured: 10,
  RefundedAndManuallyCaptured: 11,
  PaymentCapturedButNotProperlyRecorded: 12,
  Void: 13,
  Declined: 14,
  Scheduled: 15,
} as const;
